import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BookingCardContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridTemplateRows: "1fr 1fr",
  position: "relative",
  height: "min-content",
  alignSelf: "stretch",
  flexGrow: 1,
  overflow: "hidden",

  borderRadius: "1rem",
  background: theme.colors["neutral.900"],

  "@media (max-width: 600px)": {
    gridTemplateRows: "auto 1fr",
  },
}));

export const BookingCardContentContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  gridColumn: "1 / 3",
  gridRow: "1 / 3",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  zIndex: 1,
  width: "100%",

  "@media (max-width: 600px)": {
    gridColumn: "1 / 3",
    gridRow: "2 / 3",
  },
}));

export const BookingCardStatusContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  gridColumn: "2 / 3",
  gridRow: "1 / 2",
  padding: theme.space._450,
  zIndex: 1,

  "@media (max-width: 600px)": {
    gridColumn: "1 / 3",
    gridRow: "1 / 2",
    alignItems: "flex-start",
    padding: `${theme.space._400} ${theme.space._400} 0`,
  },
}));

export const TicketHolderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  minHeight: theme.space._800,
  padding: `0 ${theme.space._500}`,
  alignItems: "center",
  gap: theme.space._300,
  alignSelf: "stretch",
  backgroundImage: `linear-gradient(to left, ${theme.colors["neutral.700"]} 55%, rgba(255,255,255,0) 0%)`,
  backgroundPosition: "top",
  backgroundSize: `${theme.space._350} ${theme.space._10}`,
  backgroundRepeat: "repeat-x",
  zIndex: 1,
  flexWrap: "wrap",

  "@media (max-width: 900px)": {
    padding: theme.space._400
  }
}));

export const ButtonsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  padding: theme.space._100,
  alignItems: "center",
  gap: theme.space._200,
  backgroundColor: theme.colors["green.900"],
  borderRadius: "6.25rem",
  flex: 1,
  // TODO: Change it to something less hacky
  "& > button:first-of-type": {
    whiteSpace: "nowrap",
  },
}));

export const TicketHolder = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontStyle: "normal",
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.base,
  flex: 5,
  minWidth: "8rem"
}));

export const BadgeContainer = styled("div")(({ theme }) => ({
  marginLeft: "auto",
}));

export const UserStatusContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  minWidth: "fit-content",
  flex: 1
}));
